import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { KeyboardTimePicker, KeyboardTimePickerProps } from '@material-ui/pickers';
import React from 'react';
import { useTranslation } from 'react-i18next';

const TimePicker: React.FC<KeyboardTimePickerProps> = props => {
  const { t } = useTranslation();

  return (
    <KeyboardTimePicker
      inputVariant="outlined"
      variant="inline"
      format="HH'h'mm"
      mask="__h__"
      keyboardIcon={<AccessTimeIcon />}
      invalidDateMessage={t('customInputs.timepicker.invalidMessage')}
      disableToolbar
      autoOk
      ampm={false}
      {...props}
    />
  );
};

export default TimePicker;
